import { render, staticRenderFns } from "./SetupAccountForm.vue?vue&type=template&id=4cadefc4&"
import script from "./SetupAccountForm.vue?vue&type=script&lang=js&"
export * from "./SetupAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports